<template>
  <div class="inputDiv"
       :id="'inputDiv'+index+subIndex"
       contenteditable="true"
       @input="changeAmount"
  >{{ amount }}</div>
</template>

<script>
export default {
  name: 'inputDiv',
  props: ['amount', 'index', 'subIndex'],
  methods: {
    textareaRange(input) {
      let el = input.childNodes
      let rang = document.createRange()
      if (el.length >= 1) {
        rang.selectNodeContents(el[el.length - 1])
      }
      rang.collapse(false)
      let sel = document.getSelection()
      if (sel.anchorOffset != 0) return
      sel.removeAllRanges()
      sel.addRange(rang)
    },
    changeAmount() {
      let option = {
        amount: this.$el.innerHTML,
        index: this.index,
        subIndex: this.subIndex,
        divID: 'inputDiv' + this.index + this.subIndex
      }
      this.$emit('inputAmount', option)
      // document.getElementById('inputDiv' + this.index + this.subIndex).focus()
      // this.textareaRange(document.getElementById('inputDiv' + this.index + this.subIndex))
    }
  }
}
</script>
